import { render, staticRenderFns } from "./edit-in-sidebar-icon.vue?vue&type=template&id=5536a64d&"
import script from "./edit-in-sidebar-icon.vue?vue&type=script&lang=js&"
export * from "./edit-in-sidebar-icon.vue?vue&type=script&lang=js&"
import style0 from "./edit-in-sidebar-icon.vue?vue&type=style&index=0&id=5536a64d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports